var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 203,
    viewBox: "0 0 324 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_91546)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1603_91546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.664 71.3699C240.664 71.3699 233.055 11.8281 188.161 54.636C130.609 109.509 91.9233 0.447243 49.2298 44.9653C25.9054 69.2853 87.5397 123.676 46.3767 152.301C5.21374 180.925 38.8513 202.354 38.8513 202.354H272.585C272.585 202.354 296.782 204.101 298.614 173.484C300.442 142.866 272.315 142.495 289.772 104.18C307.229 65.865 246.15 95.7574 240.664 71.3699Z",
    fill: "#CCF0FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.936 103.616C167.089 103.616 172.888 97.8176 172.888 90.6646C172.888 83.5116 167.089 77.7129 159.936 77.7129C152.783 77.7129 146.984 83.5116 146.984 90.6646C146.984 97.8176 152.783 103.616 159.936 103.616Z",
    fill: "white",
    stroke: "#323B4B",
    strokeWidth: 0.682746,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.936 86.1387C160.037 86.892 160.103 87.6475 160.15 88.4008C160.18 88.7786 160.191 89.1541 160.212 89.5319C160.232 89.9097 160.237 90.2852 160.251 90.663L160.155 90.4377C160.656 90.8997 161.145 91.3753 161.632 91.8487C162.114 92.3289 162.599 92.8091 163.068 93.303C163.307 93.5465 163.539 93.7945 163.769 94.0471C164.001 94.2975 164.231 94.5478 164.456 94.805C164.911 95.3148 165.355 95.8337 165.776 96.3776C165.225 95.9679 164.695 95.5355 164.176 95.0917C163.915 94.8733 163.657 94.648 163.403 94.4204C163.145 94.1951 162.893 93.9675 162.642 93.7354C162.137 93.2779 161.648 92.8045 161.156 92.3335C160.672 91.8555 160.185 91.3776 159.713 90.886L159.613 90.7836L159.618 90.6607C159.631 90.2829 159.636 89.9074 159.657 89.5296C159.677 89.1519 159.688 88.7763 159.718 88.3986C159.77 87.6453 159.836 86.892 159.936 86.1387Z",
    fill: "#323B4B"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 89.8535,
    width: 29.1413,
    height: 54.2353,
    fill: "white",
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 136.803,
    width: 29.1413,
    height: 7.28533,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 129.518,
    width: 29.1413,
    height: 7.28533,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 122.232,
    width: 29.1413,
    height: 7.28533,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 114.947,
    width: 29.1413,
    height: 7.28533,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 107.662,
    width: 29.1413,
    height: 7.28533,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 100.377,
    width: 29.1413,
    height: 7.28533,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.288,
    y: 94.7109,
    width: 29.1413,
    height: 5.66637,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.146,
    y: 89.8535,
    width: 29.1413,
    height: 54.2353,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.385,
    y: 94.7109,
    width: 22.6655,
    height: 44.5215,
    fill: "white",
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7081 103.201L83.0215 105.922H94.1721L93.4855 103.201M83.7081 103.201L86.8362 90.8033V85.9652H88.5968M83.7081 103.201H93.4855M93.4855 103.201L90.3574 90.8033V85.9652H88.5968M88.5968 85.9652C88.3034 83.5461 88.7142 77.8613 92.7049 74.4746",
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.04,
    y: 93.5273,
    width: 14.6719,
    height: 12.7001,
    rx: 3.23793,
    fill: "white",
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.04 97.1543H114.712",
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.376 93.5264C105.615 93.3248 101.214 92.0145 101.214 88.3859C104.148 88.6883 105.322 89.2931 107.376 93.5264ZM107.376 93.5264C106.104 91.3089 104.383 86.0273 107.669 82.6406C110.721 86.0273 108.745 91.3089 107.376 93.5264ZM107.376 93.5264C107.376 93.8288 109.724 88.3859 114.419 88.0835C114.419 90.7445 109.724 92.8209 107.376 93.5264Z",
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.1523,
    y: 106.225,
    width: 46.9499,
    height: 5.4429,
    stroke: "#8A94A6",
    strokeWidth: 1.61896
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.5547 201.99H261.276",
    stroke: "#8A94A6",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.076 201.99H296.602",
    stroke: "#8A94A6",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.865 201.864H119.832C117.007 201.864 114.616 199.613 114.236 196.599L109.25 156.709H200.447L195.462 196.599C195.082 199.616 192.691 201.864 189.865 201.864Z",
    fill: "white",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.007 164.095H109.69C106.455 164.095 103.832 161.473 103.832 158.237L103.283 151.96C103.252 151.605 103.532 151.301 103.887 151.301H205.807C206.162 151.301 206.442 151.608 206.411 151.96L205.861 158.237C205.864 161.473 203.242 164.095 200.007 164.095Z",
    fill: "#009FE3",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.848 194.758C153.378 194.758 152.187 193.567 152.187 192.099V173.787C152.187 172.32 153.378 171.129 154.845 171.129H154.848C156.316 171.129 157.507 172.32 157.507 173.787V192.099C157.507 193.567 156.316 194.758 154.848 194.758Z",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.832 194.758C142.367 194.889 141.076 193.81 140.945 192.349L139.311 174.11C139.18 172.649 140.258 171.357 141.72 171.224H141.723C143.184 171.093 144.476 172.172 144.609 173.633L146.244 191.872C146.372 193.336 145.293 194.628 143.832 194.758Z",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66 194.757C130.208 194.982 128.847 193.991 128.622 192.539L125.802 174.446C125.577 172.997 126.568 171.636 128.02 171.411H128.023C129.473 171.186 130.834 172.176 131.059 173.629L133.878 191.722C134.103 193.171 133.112 194.532 131.66 194.757Z",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 194.758C167.965 194.889 169.256 193.81 169.387 192.349L171.021 174.11C171.152 172.649 170.073 171.357 168.612 171.224H168.609C167.147 171.093 165.856 172.172 165.722 173.633L164.088 191.872C163.957 193.336 165.039 194.628 166.5 194.758Z",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.669 194.757C180.121 194.982 181.482 193.991 181.707 192.539L184.526 174.446C184.751 172.997 183.761 171.636 182.309 171.411H182.305C180.856 171.186 179.495 172.176 179.27 173.629L176.451 191.722C176.226 193.171 177.219 194.532 178.669 194.757Z",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.816 160.887C126.431 159.45 125.729 156.311 127.282 153.996L143.607 129.629C144.634 128.098 146.681 127.639 148.261 128.593C149.841 129.544 150.397 131.567 149.522 133.193L135.625 159.021C134.303 161.47 131.201 162.321 128.816 160.887Z",
    fill: "#FFE000",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.538 158.25C132.474 158.25 133.234 157.491 133.234 156.555C133.234 155.618 132.474 154.859 131.538 154.859C130.602 154.859 129.843 155.618 129.843 156.555C129.843 157.491 130.602 158.25 131.538 158.25Z",
    fill: "white",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.457 160.887C185.842 159.45 186.544 156.311 184.991 153.996L168.666 129.629C167.639 128.098 165.591 127.639 164.012 128.593C162.432 129.544 161.876 131.567 162.751 133.193L176.648 159.021C177.969 161.47 181.072 162.321 183.457 160.887Z",
    fill: "#FFE000",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.737 158.25C181.674 158.25 182.433 157.491 182.433 156.555C182.433 155.618 181.674 154.859 180.737 154.859C179.801 154.859 179.042 155.618 179.042 156.555C179.042 157.491 179.801 158.25 180.737 158.25Z",
    fill: "white",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.253 152.65L230.715 149.01C230.724 148.943 230.809 148.922 230.849 148.976L232.973 151.966C233.003 152.009 232.982 152.069 232.93 152.082L230.345 152.732C230.296 152.744 230.247 152.701 230.253 152.65Z",
    fill: "#FFE000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.002 152.055L230.271 152.74L236.027 175.678L238.759 174.993L233.002 152.055Z",
    fill: "white",
    stroke: "#8A94A6",
    strokeWidth: 0.607658,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.435 149.498C250.435 149.498 250.237 152.807 247.743 153.266C245.774 153.627 246.53 156.471 248.955 156.699C250.863 156.878 253.756 154.958 250.435 149.498Z",
    fill: "#FFE000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.158 175.303L245.498 175.889L250.948 156.244L247.047 155.654L243.158 175.303Z",
    fill: "white",
    stroke: "#8A94A6",
    strokeWidth: 0.607658,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.778 181.236L236.137 180.853C236.112 180.853 236.094 180.832 236.097 180.807L237.853 150.348C237.853 150.324 237.874 150.306 237.899 150.309L244.54 150.692C244.565 150.692 244.583 150.713 244.58 150.737L242.824 181.196C242.821 181.217 242.799 181.236 242.778 181.236Z",
    fill: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.44 152.562L239.124 152.602",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.385 153.518L239.068 153.557",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.331 154.473L239.015 154.512",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.275 155.43L238.959 155.469",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.221 156.389L238.901 156.428",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.163 157.344L238.847 157.383",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.109 158.303L238.793 158.342",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.054 159.26L238.737 159.299",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.999 160.211L238.683 160.25",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.944 161.17L238.628 161.209",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.89 162.127L238.57 162.166",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.832 163.082L238.516 163.122",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.777 164.041L238.461 164.081",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.724 164.998L238.407 165.038",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.668 165.953L238.352 165.993",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.613 166.908L238.297 166.948",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.559 167.867L238.239 167.907",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.501 168.824L238.185 168.864",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.446 169.779L238.13 169.819",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.392 170.738L238.075 170.778",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.337 171.695L238.021 171.735",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.282 172.648L237.966 172.688",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.228 173.605L237.908 173.645",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.17 174.564L237.854 174.604",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.115 175.52L237.799 175.559",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.061 176.477L237.744 176.516",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.006 177.436L237.689 177.475",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.951 178.391L237.635 178.427",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.896 179.346L237.577 179.385",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.839 180.303L237.522 180.342",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.784 181.258L237.468 181.297",
    stroke: "#323B4B",
    strokeWidth: 0.303829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.32 201.572H235.045C234.747 201.572 234.489 201.225 234.41 200.727L229.643 170.62C229.528 169.888 229.844 169.162 230.278 169.162H251.084C251.522 169.162 251.838 169.888 251.719 170.62L246.952 200.727C246.876 201.225 246.618 201.572 246.32 201.572Z",
    fill: "#FFE000",
    stroke: "#323B4B",
    strokeWidth: 1.61896,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_91546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323.793,
    height: 202.37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1603_91546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.046,
    height: 168.457,
    fill: "white",
    transform: "translate(25.9043 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.fe239d9a3929b4a96a1e5fccb3e769c4.svg";
export { ForwardRef as ReactComponent };